module.exports = __webpack_public_path__ + "static/401-8ab2fec87aea2f7528e509f32814f9a9.png";